import React, { useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import dancer_1 from '../assets/images/dancer_1.png';
import dancer_2 from '../assets/images/dancer_2.png';
import dancer_3 from '../assets/images/dancer_3.png';
import dancer_4 from '../assets/images/dancer_4.png';
import { API_URL } from '../config';
import { useSelector, useDispatch } from 'react-redux';
import EDSFooter from '../components/EDSFooter';
import { setMessege } from '../reducers/reposReducers';
 

const Operacja_w_toku = () => {
    const history = useHistory();
    const proxySendURL = `${API_URL}ProxySend`;
    const key = useSelector((state) => state.repos.chName);
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const entryFee = useSelector((state) => state.repos.entryFee);
    const dateToBay = useSelector((state) => state.repos.date);
    const getGroup = useSelector((state) => state.repos.groups);
    const users = useSelector((state) => state.repos.users);
    const usersParticipant = useSelector((state) => state.repos.usersParticipant);
    const allInstallments = useSelector((state) => state.repos.allInstallments);
    const selectedInstallments = useSelector((state) => state.repos.selectedInstallments);
    const selectPromotions = useSelector((state) => state.repos.promotionsSalesIDArray);
    const nip = useSelector((state) => state.repos.nip);
    const dispatch = useDispatch();
    const paymentData = useSelector((state) => {
        return state.repos.payForm;
    });

    const allInstallmentsPrice = useSelector((state) => state.repos.allInstallmentsPrice);
    const numLength = getGroup.paymentShedule.length-1;

    const formData = {
        type: 'Order',
        body: {
            allInstallments: allInstallments,
            paymentMethodsDVID: paymentData.selectedPaymentMethod,
            paymentCardID: paymentData.selectedCard,
            buyerNIP: nip,
            purchaseKey: key,
            current_LocalizationsID: -1,
            contractPeriodFrom: dateToBay,
            usersID: usersParticipant ? usersParticipant.usersID: users.usersID, // uczestnik
            payer_UsersID: users.usersID,                            // płatnik
            productsID: getGroup.productsID, // localStorage.getItem('productsID'),
            coursesHeadingsID: getGroup.coursesHeadingsID, //  localStorage.getItem('coursesHeadingsID')
            contractAmount: +allInstallmentsPrice.toFixed(2),
            paymentStatusesDVID: 1,
            arrayOfSelectedInstallments: selectedInstallments.toString(),
            entryFee: entryFee.priceDiscount ? entryFee.priceDiscount : 0,
            promotionsSalesIDList: selectPromotions? selectPromotions.join(','): '',
            dataTo: getGroup.paymentShedule[numLength]?.periodToDate,
        },
    };

    let globalResponse;
    const methodProxySend = () => {
        axios
            .post(proxySendURL, formData, config)
            .then((response) => {
                globalResponse = response.data.requestId;
                if(response.data.recheck){
                    methodProxyGetMessage();
                } else {
                    if(response.data.message === 'Other requested'){
                        // umowa jest utworzona under reckwestet
                        dispatch(setMessege('Taka umowa jest już utworzona.'));
                        history.push(`/potwierdzenie_zakupu_powturne`);
                    } 
                    if(response.data.message !== 'Other requested'){
                        // umowa jest w trakcie procesowania uder create
                        dispatch(setMessege('Umowa jest w trakcie tworzenia.'));
                        history.push(`/potwierdzenie_zakupu_powturne`);
                    }
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    history.push('/Error_ogolny');
                }
            });
    };

    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, config)
            .then((proxyGetMessageUrlResponse) => {
                if (proxyGetMessageUrlResponse.data.recheck == false) {
                    if(proxyGetMessageUrlResponse.data.responseBody.status == 400){
                        history.push('/Error_ogolny');
                    }
                    if(proxyGetMessageUrlResponse.data.responseBody.body.html){
                       window.location.replace(proxyGetMessageUrlResponse.data.responseBody.body.html);
                    } else if(proxyGetMessageUrlResponse.data.responseBody.body.key === 20){
                        history.push(`/Potwierdzenie_zakupu/${proxyGetMessageUrlResponse.data.responseBody.body.sessionID}`);
                    } 
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 6000);
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        history.push('/Error_ogolny');
                    }
                } else {
                    window.location.replace(
                        'https://panelklienta.egurrola.com/Error_ogolny'
                    );
                }
            });
    };

    useEffect(() => {
        methodProxySend();
    }, []);

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content responsive-padding margin-top-32">
                <div className="operacja">
                    <h2 className="operacja__caption">Operacja w toku</h2>
                    <div className="operacja__images">
                        <img
                            src={dancer_1}
                            alt="Tancerz"
                            className="operacja__img operacja__img--1"
                        />
                        <img
                            src={dancer_2}
                            alt="Tancerz"
                            className="operacja__img operacja__img--2"
                        />
                        <img
                            src={dancer_3}
                            alt="Tancerz"
                            className="operacja__img operacja__img--3"
                        />
                        <img
                            src={dancer_4}
                            alt="Tancerz"
                            className="operacja__img operacja__img--4"
                        />
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Operacja_w_toku;
